// Client-safe public site URL. Reads only VITE_* (never private secrets).
// Use this in components/footers/links instead of hardcoding the domain.
export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) ??
  "https://truckcompanycenter.com";
